/* tslint:disable */
/* eslint-disable */

/**
 * Types de formulaires
 *
 * 0 = CodesAccesVisiteur
 * 1 = DemandeQuotaSupplementaire
 * 2 = AccesResidentHorsZoneIC
 */
export enum TypesFormulaires {
  CodesAccesVisiteur = 0,
  DemandeQuotaSupplementaire = 1,
  AccesResidentHorsZoneIC = 2
}
